import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoutes from "./PrivateRoutes";
import SignIn from "../Auth";
import ForgotPassword from "../Pages/Auth/ForgotPassword";

export default function Routers() {
  const login = localStorage.getItem("login");

  return (
    <BrowserRouter>
      <Routes>
        {/* Redirect root route based on login */}
        <Route
          path="/"
          element={
            login ? (
              <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />
            ) : (
              <Navigate to={`${process.env.PUBLIC_URL}/login`} />
            )
          }
        />

        {/* Protected routes */}
        <Route path="/" element={<PrivateRoutes />}>
          <Route path="/*" element={<LayoutRoutes />} />
        </Route>

        {/* Public routes */}
        <Route path={`${process.env.PUBLIC_URL}/login`} element={<SignIn />} />
        <Route path={`${process.env.PUBLIC_URL}/forgot-password`} element={<ForgotPassword />} />
      </Routes>
    </BrowserRouter>
  );
}